import React from 'react';
import { Card, Spinner } from 'reactstrap';

const Loader = () => {
    return (
        <React.Fragment>
            <Card className="loader-main">
                <div className="loader-box">
                    <Spinner color="primary" className="spinner-style" />
                    <strong className="loading-style">Loading...</strong>
                </div>
            </Card>
        </React.Fragment>
    );
};

export default Loader;
